module.exports = __webpack_public_path__ + "static/icons/alerta.58893be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/characters/alerta.svg
// module id = AI+X
// module chunks = 1